import { Component } from 'react';
import {Footer, SideNav, TopBar} from '../partials/layouts.js';
import {LogoutModal} from './logout.js';
import {postFile, deleteItem} from './constants.js';
const moment = require('moment');

class NewsletterList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data          :[],
      isLoading     :true,
      show          :false
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.addNewsletter = this.addNewsletter.bind(this);
    this.editNewsletter = this.editNewsletter.bind(this);
    this.deleteNewsletter = this.deleteNewsletter.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
  }

  async getNewsletters() {
    try {
      const response = await fetch('/api/news_letters');
      const json = await response.json();
      this.setState({ data: json });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    this.getNewsletters();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleFileChange(event){
    this.setState({
      "filename": event.target.files[0].name
    })
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({ show: false, isLoading: true });
    var formData = new FormData();
    var file = document.getElementById("inputGroupFile02").files[0];
    formData.append('File', file);
    const data = this.state;
    delete data.data;
    delete data.isLoading;
    formData.append('jsonData', JSON.stringify(data));

    if(data.id){
      postFile('/api/news_letter/'+data.id, formData)
        .then((response) => {
          console.log(response);
          this.getNewsletters();
      });
    }else{
      postFile('/api/news_letter', formData)
        .then((response) => {
          console.log(response);
          this.getNewsletters();
      });
    }
  }

  addNewsletter() {
    this.setState({
      id       :"",
      title    :"",
      file_url :"",
      show     :true
    });
  }

  editNewsletter(e) {
    const id = parseInt(e.target.id);
    const news_letters = this.state.data;
    const selectedNewsletter = news_letters.filter(e=> e.id === id)[0];
    this.setState(selectedNewsletter);
    this.setState({ show: true, filename: "" });
  }

  deleteNewsletter(e) {
    const id = parseInt(e.target.id);
    deleteItem("/api/news_letter/"+id)
    .then((response) => {
      console.log(response);
      this.getNewsletters();
    });
  }

  render() {
    if(!this.state.isLoading){
      const news_letters = this.state.data;
      const news_letter_list = news_letters.map((news_letter)=>
          <tr key={news_letter.id} id={news_letter.id}>
              <td>{moment(news_letter.created_date).format('l')}</td>
              <td>{news_letter.title}</td>
              <td>{news_letter.posted_by}</td>
              <td>
                <div className="row">
                  <div className="col">
                  {news_letter.file_url &&
                    <a id={news_letter.id} href={news_letter.file_url} target="_blank"><i className="fas fa-file text-secondary action-icons"></i></a>
                  }
                  </div>
                  <div className="col">
                    <i id={news_letter.id} className="fas fa-pencil-alt text-warning action-icons" onClick={this.editNewsletter}></i>
                  </div>
                  <div className="col">
                    <i id={news_letter.id} className="fas fa-trash-alt text-danger action-icons" onClick={this.deleteNewsletter}></i>
                  </div>
                </div>
              </td>
          </tr>
      );
      return(
          <>
          <div className="row">
              <div className="col-lg-8 col-md-7 col-xs-12">
                  <div className="card shadow mb-2">
                      <div className="card-header py-3">
                          <h4 className="m-0 font-weight-bold text-white">Newsletter</h4>
                      </div>
                      <div className="card-body">
                          <div className="table-responsive newsletter-table">
                              <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                  <thead>
                                      <tr>
                                          <th>Created On</th>
                                          <th>Title</th>
                                          <th>Posted By</th>
                                          <th></th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      {news_letter_list}
                                  </tbody>
                              </table>
                          </div>
                      </div>
                  </div>
                  <button className="btn btn-primary" onClick={this.addNewsletter}><i className="fas fa-plus"></i> Newsletter</button>
              </div>
              <div className="col-lg-4 col-md-5 col-xs-12">
                {this.state.show?(
                  <div className="card shadow mb-2">
                      <div className="card-header py-3">
                          <h4 className="m-0 font-weight-bold text-light">Add / Edit Newsletter</h4>
                      </div>
                      <div className="card-body newsletter-form">
                          <form className="user" onSubmit={this.handleSubmit} autoComplete="off">
                              <div className="form-group">
                                  <label>Newsletter Title</label>
                                  <input type="text" name="title" className="form-control" value={this.state.title} onChange={this.handleInputChange} required />
                              </div>
                              <div className="form-group">
                                <label>Upload Newsletter File </label>
                                <div className="input-group">
                                    <div className="custom-file">
                                       <input type="file" className="custom-file-input text-bold" id="inputGroupFile02" onChange={this.handleFileChange} aria-describedby="inputGroupFileAddon04" />
                                       <label className="custom-file-label" for="inputGroupFile02">Choose File</label>
                                    </div>
                                </div>
                                <p className="text-success">{this.state.filename}</p>
                              </div>
                              <div className="form-group">
                                <input type="submit" id="news_letter-submit" className="btn btn-bg-success" value="Submit" />
                                <button type="button" name="cancel" className="btn btn-danger float-right" onClick={()=> this.setState({show:false})}>Cancel</button>
                              </div>
                              {this.state.file_url?
                                <>
                                  <h6>File</h6>
                                  <a href={this.state.file_url} target="_blank">{this.state.file_url}</a>
                                </>:<></>
                              }
                          </form>
                      </div>
                  </div>
                ):(<>
                  </>
                )}
              </div>
          </div>
          </>
      );
    }
  }
}

function NewsLetters() {
  return (
    <>
        <div id="wrapper">
            <SideNav />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopBar />
                    <div className="container-fluid">
                        <NewsletterList />
                    </div>
                </div>
                <Footer />
            </div>
        </div>
        <a className="scroll-to-top rounded" href="#page-top">
            <i className="fas fa-angle-up"></i>
        </a>
        <LogoutModal />
    </>
  );
}

export { NewsLetters };
